import store from '../../store'
/* 按钮显示 */
function btnShow(fieldKey){
	//尝试读取store里的设置
	let btnSettings = store.state.btnSettings
	if(!btnSettings) return false
  let target = btnSettings.find(item => item.fieldKey == fieldKey)
	if(!target) return false
	return target.display
}
/* 工单列表显示 */
function workOrderShow(rank){
	//尝试读取store里的设置
	let workOrderSettings = store.state.workOrderSettings
	console.log(workOrderSettings)
	if(!workOrderSettings) return false
  let target = workOrderSettings.find(item => item.rank == rank)
	if(!target) return false
	return target.display
}
export default {
  btnShow,
	workOrderShow
}